"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _Duration = _interopRequireDefault(require("web/shared/telemetry/components/Duration"));
var _PercentileStripData = require("web/shared/telemetry/charts/PercentileStrip.data.js");
var _durations = require("web/shared/telemetry/format/durations.js");
var _PercentileStripStyles = require("web/shared/telemetry/charts/PercentileStrip.styles.js");
var _perfViewsStyles = require("web/shared/telemetry/perfViews.styles.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* The summary above everything else: the same durations as a row of figures.
*
* Read left to right as a scale, which is why it is one row and why a few of
* the figures are emphasized — without a hierarchy a reader scans the whole
* row to reach the few they came for.
*/
function PercentileStrip(_ref) {
  let records = _ref.records;
  const figures = (0, _PercentileStripData.buildPercentiles)((0, _durations.completedDurationsMs)(records));
  if (figures.length === 0) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_PercentileStripStyles.styles.figureStrip)), {}, {
    children: figures.map((figure, index) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(React.Fragment, {
      children: [index > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)({}, stylex.props(_PercentileStripStyles.styles.figureDivider))) : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_PercentileStripStyles.styles.figure, figure.emphasized && _PercentileStripStyles.styles.figureEmphasized)), {}, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_PercentileStripStyles.styles.figureValue, figure.emphasized && _PercentileStripStyles.styles.figureValueEmphasized)), {}, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Duration.default, {
            ms: figure.ms
          })
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.muted, figure.emphasized && _PercentileStripStyles.styles.figureLabelEmphasized)), {}, {
          children: figure.label
        }))]
      }))]
    }, figure.label))
  }));
}
var _default = exports.default = PercentileStrip;